export default __webpack_public_path__ + "546134f.png";